import React from "react";
import { useAppSelector } from "../../../redux/store";
import FormPage from "../../common/formpage/formpage";
import AvatarHeader from "../../common/avatar-header/avatar-header";
import { Props } from "./menu-page";
import { useSmartNavigate } from "../../../hooks/useSmartNavigate";

type FormProps = Props & {
  submit: () => void;
  ready?: boolean;

  submitText?: string;
  loadingText?: string;
};

const MenuFormPage: React.FunctionComponent<FormProps> = (props) => {
  const navigate = useSmartNavigate();

  const playerDetails = useAppSelector((state) => state.menu.playerDetails);

  const metaState = useAppSelector((state) => state.meta);

  function handleSubmit() {
    if (props.submit) {
      props.submit();
    }
  }

  function handleBack() {
    if (props.overrideBack) {
      props.overrideBack();
    } else {
      // If there's no previous page in the session's history stack for this app,
      // navigate to the main page. Otherwise, go back one step.
      if (window.history.state?.idx === 0 || window.history.state === null) {
        navigate("/");
      } else {
        navigate(-1);
      }
    }
  }

  return (
    <FormPage
      header={
        <AvatarHeader
          hideAvatar={props.hideAvatar}
          titles={props.titles}
          titlesJsx={props.titlesJsx}
          avatarName={playerDetails?.name}
          avatarSpriteId={playerDetails?.meta.sprite_id}
        />
      }
      subHeaderJsx={props.subHeaderJsx}
      subHeaders={props.subHeaders}
      loadingText={props.loadingText}
      submitText={props.submitText}
      onBack={handleBack}
      error={metaState.error}
      onSubmit={handleSubmit}
      hideConnected={true}
      ready={props.ready}
      loading={metaState.loading}
    >
      {props.children}
    </FormPage>
  );
};

export default MenuFormPage;
